"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVolumeIndicatorCallback = void 0;
const streem_logger_1 = require("../util/streem_logger");
const createVolumeIndicatorCallback = (callbackAttendeeId, onAudioLevelChange, onRemoteSignalStrengthChange) => (attendeeId, volume, muted, signalStrength, streemUserId) => {
    if (attendeeId !== callbackAttendeeId) {
        return;
    }
    // infer based on the presence of onRemoteSignalStrengthChange
    const isRemoteYn = !!onRemoteSignalStrengthChange;
    streem_logger_1.streemLogger.debug(`Audio track volume changed for attendee=${attendeeId} volume: ${volume}, muted: ${muted}, userId=${streemUserId !== null && streemUserId !== void 0 ? streemUserId : 'unknown'}, remote=${isRemoteYn}, signalStrength: ${signalStrength}`);
    // convert from 0-1 to a 0-10 scale
    onAudioLevelChange(Math.round((volume !== null && volume !== void 0 ? volume : 0) * 10));
    // I have an open support ticket with AWS to clarify the meaning of signalStrength = null, but for now ignore it
    if (onRemoteSignalStrengthChange && typeof signalStrength === 'number') {
        streem_logger_1.streemLogger.debug('calling onRemoteSignalStrengthChange with', { signalStrength });
        onRemoteSignalStrengthChange(signalStrength);
    }
    // according to Chime docs, a signalStrength below of 0.5 or below indicates packet loss:
    //     https://aws.github.io/amazon-chime-sdk-js/modules/qualitybandwidth_connectivity.html#events-for-monitoring-remote-attendee-uplink
    if (typeof signalStrength === 'number' && signalStrength <= 0.5) {
        streem_logger_1.streemLogger.warn(`Audio track signal strength is low for attendeeId=${attendeeId} signalStrength: ${signalStrength}, userId=${streemUserId !== null && streemUserId !== void 0 ? streemUserId : 'unknown'} remote=${isRemoteYn}`);
    }
};
exports.createVolumeIndicatorCallback = createVolumeIndicatorCallback;
//# sourceMappingURL=volume_indicator_callback.js.map